// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3WZkk","productName":"Table_productName__2ZSe6"};